import React, { useEffect, useRef, useState } from 'react'
import NotificationSystem from 'react-notification-system'
import ajax from '../common/components/ajax.jsx'
import Constants from '../common/components/constants.jsx'
import cookie from 'react-cookie';
import '../sass/login.scss'
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const defaultTheme = createTheme();

function Login(props) {
    const[uid, setUid] = useState(cookie.load('uid'))
    const[password, setPassword] = useState(cookie.load('uid'))
    const[saveUid, setSaveUid] = useState(!!cookie.load('saveUid'))

    const notificationSystemRef = useRef();

    useEffect(()=>{
        if(props.auth?.loggedIn){
            document.location.href = '/';
        }
    },[props.auth?.loggedIn])

    const addNotification = (title, level, message, errorcode, uid) => {
        notificationSystemRef.current.addNotification({
            title: title,
            message: message,
            level: level,
            position: 'tc',
            autoDismiss: 3,
            uid: uid
        });
    }
    const forceLogout =(handler) =>{
        ajax.get(
            Constants.URLs.LOGOUT,
            (success) => {
                console.log('Logout successed.');
                props.auth.onLoginStatusChange(false);
                handler(true);
            },
            (error) => {
                console.log('Logout failed.');
                handler(false);
            },
        );
    }

    const handleSubmit=(evt)=> {
        evt.preventDefault();

        if(!uid || !password){
            const target = !uid? 'アカウントID' : 'パスワード';

            addNotification(
                'Error',
                'warning',
                target + 'を入力してください',
                0,
                0
            );
            return;
        }

        // IDを保存するにチェックが入っている場合はIDを、そうでなければ空白を Cookie に書き込む
        cookie.save('uid', saveUid? uid : '', { path: '/' });

        // IDを保存するのチェック状態を Cookie に書き込む
        cookie.save( 'saveUid', saveUid, { path: '/' });

        const loginPostData = {
            user_id:  uid,
            password: password,
        }

        ajax.post(
            Constants.URLs.LOGIN,
            loginPostData,
            (successJson) => {
                if(!successJson.hasOwnProperty('data')){
                    addNotification('Error', 'error', 'ログインに失敗しました。必要な情報が取得できませんでした。',　-1, -1);
                    return;
                }

                const data = successJson.data;
                console.log('Login Successed: ', data);

                const loggedIn    = data.hasOwnProperty('LOGGED_IN'   )? data.LOGGED_IN    : false;
                const userId      = data.hasOwnProperty('USER_ID'     )? data.USER_ID      : '';
                const displayName = data.hasOwnProperty('DISPLAY_NAME')? data.DISPLAY_NAME : '';
                const role        = data.hasOwnProperty('ROLE'        )? data.ROLE         : {};

                props.auth.onLoginStatusChange(loggedIn, userId, displayName, role);
            },
            (errorJson) => {
                console.log('Login Failed: ', errorJson);

                // すでにログインされている場合
                if(errorJson.httpStatus === 412){
                    forceLogout(successed => {
                        if(!successed){
                            addNotification('Error', 'error', errorJson.message, errorJson.code, errorJson.code);
                            return;
                        }

                        ajax.post(
                            Constants.URLs.LOGIN,
                            loginPostData,
                            (successJson) => {
                                if(!successJson.hasOwnProperty('data')){
                                    addNotification('Error', 'error', 'ログインに失敗しました。必要な情報が取得できませんでした。',　-1, -1);
                                    return;
                                }

                                const data = successJson.data;
                                console.log('Login Retry Successed: ', successJson.data);

                                const loggedIn    = data.hasOwnProperty('LOGGED_IN'   )? data.LOGGED_IN    : false;
                                const userId      = data.hasOwnProperty('USER_ID'     )? data.USER_ID      : '';
                                const displayName = data.hasOwnProperty('DISPLAY_NAME')? data.DISPLAY_NAME : '';
                                const role        = data.hasOwnProperty('ROLE'        )? data.ROLE         : {};

                                props.auth.onLoginStatusChange(loggedIn, userId, displayName, role);
                            },
                            (errorJson) => {
                                console.log('Login Retry Failed: ', errorJson);
                                if(errorJson.code !== 401){
                                    addNotification('Error', 'error', errorJson.message, errorJson.code, errorJson.code)
                                    return;
                                }
                            }
                        );
                    });
                    return;
                }

                if(errorJson.code !== 401){
                    addNotification('Error', 'error', errorJson.message, errorJson.code, errorJson.code);
                    return;
                }
            }
        )
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <div className='container clearfix login_box'>
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box className="form-signin">
                        <Box className='top_logo' />
                        <Box
                         component="form"
                         onSubmit={handleSubmit}
                         noValidate
                         sx={{ mt: 1 }}
                        >
                            <TextField
                             margin="normal"
                             required
                             fullWidth
                             id="email"
                             label="ログインID"
                             name="email"
                             autoComplete="email"
                             autoFocus
                             onChange={(evt) => { setUid(evt.currentTarget.value) }}
                            />
                            <TextField
                             margin="normal"
                             required
                             fullWidth
                             name="password"
                             label="パスワード"
                             type="password"
                             id="password"
                             autoComplete="current-password"
                             onChange={(evt) => { setPassword(evt.currentTarget.value) }}
                            />
                            <FormControlLabel
                             control={<Checkbox value={saveUid} color="primary" onChange={() => { setSaveUid(!saveUid) }} />}
                             label="IDを記憶する"
                            />
                            <Button
                             type="submit"
                             fullWidth
                             variant="contained"
                             sx={{ mt: 3, mb: 2 }}
                             onClick={(evt) => { handleSubmit(evt); }}
                            >
                            サインイン
                            </Button>
                        </Box>
                        <NotificationSystem ref={notificationSystemRef}/>
                    </Box>
                </Container>
            </div>
            <NotificationSystem ref={notificationSystemRef}/>
        </ThemeProvider>
      );

}

export default Login;
